import type { AppState } from '../../app/stores.js';

type FeedView = Pick<AppState, 'reviewTopicIds' | 'soloTopicIds' | 'savedFilter' | 'searchQuery' | 'categoryFilter'>;

/** Effective query identity, excluding pagination and refreshed story data. */
export function feedViewKey(state: FeedView): string {
  const topicSet = (ids: readonly string[]): string[] => [...new Set(ids)].sort();
  if (state.reviewTopicIds.length > 0) return JSON.stringify(['review', topicSet(state.reviewTopicIds)]);
  const category = effectiveCategoryFilter(state.categoryFilter, state.soloTopicIds);
  return JSON.stringify([
    'feed',
    topicSet(state.soloTopicIds),
    state.savedFilter,
    state.searchQuery.trim(),
    category?.category ?? null,
    category?.subcategory ?? null,
  ]);
}

/** Solo owns topic scope while active; the saved taxonomy choice remains untouched. */
export function effectiveCategoryFilter(
  selected: AppState['categoryFilter'],
  soloTopicIds: readonly string[],
): AppState['categoryFilter'] {
  return soloTopicIds.length > 0 ? null : selected;
}
